export var MedicalTitleName;
(function (MedicalTitleName) {
    // Unsupported titles
    /** Medical Assistant */
    MedicalTitleName["MA"] = "ma";
    /** Medical Doctor */
    MedicalTitleName["MD"] = "md";
    /** Nurse Practitioner */
    MedicalTitleName["NP"] = "np";
    /** Naturopathic Doctor */
    MedicalTitleName["ND"] = "nd";
    /** Physician Assistant */
    MedicalTitleName["PA"] = "pa";
    // Supported titles
    /** Licensed Vocational Nurse */
    MedicalTitleName["LVN"] = "lvn";
    MedicalTitleName["PHLEBOTOMIST"] = "phlebotomist";
    /** Registered Nurse */
    MedicalTitleName["RN"] = "rn";
})(MedicalTitleName || (MedicalTitleName = {}));
/**
 * Ordered medical titles from highest to lowest
 */
export const orderedMedicalTitleRanking = [
    MedicalTitleName.RN,
    MedicalTitleName.LVN,
    MedicalTitleName.PHLEBOTOMIST,
];
export var ProcedureFlowType;
(function (ProcedureFlowType) {
    /**
     * Procedure flow including:
     * - Product selection
     * - Generic files upload (optional)
     * - Nurse instructions (optional)
     * - Fasting instructions (optional)
     */
    ProcedureFlowType["GENERIC"] = "generic";
    /**
     * Procedure flow including:
     * - Product selection
     * - Requisition form upload (optional)
     * - Diagnosis
     * - Nurse instructions (optional)
     * - Fasting instructions
     * - Lab selection
     */
    ProcedureFlowType["LAB_DRAW"] = "labDraw";
    /**
     * Procedure flow including:
     * - Product selection
     */
    ProcedureFlowType["POINT_OF_CARE"] = "pointOfCare";
})(ProcedureFlowType || (ProcedureFlowType = {}));
export var InstructionType;
(function (InstructionType) {
    InstructionType["CHARTING"] = "charting";
    InstructionType["STORAGE"] = "storage";
    InstructionType["DRAWING"] = "drawing";
    InstructionType["SAMPLE_MANIPULATION"] = "sampleManipulation";
    InstructionType["POST_PROCEDURE"] = "postProcedure";
    InstructionType["FASTING"] = "fasting";
    InstructionType["PATIENT"] = "patient";
    InstructionType["CONSENT"] = "consent";
    InstructionType["NURSE"] = "nurse";
    InstructionType["DIAGNOSIS"] = "diagnosis";
    InstructionType["LAB"] = "lab";
})(InstructionType || (InstructionType = {}));
export var ConfigType;
(function (ConfigType) {
    ConfigType["PCR"] = "pcr";
    ConfigType["TUBE"] = "tube";
    ConfigType["URINE"] = "urine";
})(ConfigType || (ConfigType = {}));
export var DurationType;
(function (DurationType) {
    DurationType["PREPARATION"] = "preparation";
    DurationType["PROCEDURE"] = "procedure";
    DurationType["OBSERVATION"] = "observation";
})(DurationType || (DurationType = {}));
//# sourceMappingURL=variables.js.map